module.exports = __webpack_public_path__ + "img/type_video.f9c48b85.svg";